import { URL_BASE } from "../../constants/url";
import {
  composeErrorNotification,
  composeSuccessNotification,
} from "../../utils/composeNotification";
import { post } from "../../utils/fetch";
import { startLoadAsistencia } from "./detalleActions";
import { notification } from "./notificationActions";

export const startSetDatosCobro = (body) => {
  return async (dispatch) => {
    const result = await post(`${URL_BASE}/api/CobrosCabina/DatosCobro`, body);
    if (result.code === 0) {
      dispatch(startLoadAsistencia(body.asistenciaID));
      dispatch(notification(composeSuccessNotification(result.data)));
    } else {
      dispatch(notification(composeErrorNotification(`${result.error}`)));
    }
  };
};